export default {
	"distribution": {
		"distribution": "distribute",
		"cancelDistribution": "undo assignment"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/distribution/distribution.js